import { useIntlState } from '@/composables/useIntlState'

export function getUrlFromList(list: string): string {
  const urls = list.split(',').map(e => e.trim())
  const { isInternational } = useIntlState()

  return (
    urls.find(e => {
      const url = new URL(e)
      if (url.host === 'kinescope.io') return true
      return isInternational.value ? url.host.endsWith('.com') : url.host.endsWith('.ru')
    }) ?? urls[0]
  )
}

export function getThumbnailUrl(url: string): string | undefined {
  const videoUrl = new URL(url, window.location.origin)
  const ytThumbUrl = new URL('https://img.youtube.com/')

  if (videoUrl.host.endsWith('youtube.com')) {
    ytThumbUrl.pathname = `/vi/${videoUrl.searchParams.get('v')}/hqdefault.jpg`
    return ytThumbUrl.toString()
  }

  if (videoUrl.host.endsWith('youtu.be')) {
    ytThumbUrl.pathname = `/vi${videoUrl.pathname}/hqdefault.jpg`
    return ytThumbUrl.toString()
  }

  if (videoUrl.host.endsWith('rutube.ru')) {
    const pathParts = videoUrl.pathname.split('/')
    const videoId = pathParts[pathParts.length - 2]
    return `https://rutube.ru/api/video/${videoId}/thumbnail/?redirect=1`
  }

  if (videoUrl.host === 'kinescope.io') {
    const pathParts = videoUrl.pathname.split('/')
    const videoId = pathParts[pathParts.length - 1]
    return new URL(`https://kinescope.io/${videoId}/poster.webp`).toString()
  }

  return undefined
}

export function getFrameSrc(url: string): string {
  const videoUrl = new URL(url, window.location.origin)

  const ytEmbedUrl = new URL('https://www.youtube.com/')
  ytEmbedUrl.searchParams.set('rel', '0')

  if (videoUrl.host.endsWith('youtube.com')) {
    ytEmbedUrl.pathname = `/embed/${videoUrl.searchParams.get('v')}`
    return ytEmbedUrl.toString()
  }

  if (videoUrl.host.endsWith('youtu.be')) {
    ytEmbedUrl.pathname = `/embed${videoUrl.pathname}`
    return ytEmbedUrl.toString()
  }

  if (videoUrl.host.endsWith('rutube.ru')) {
    const pathParts = videoUrl.pathname.split('/')
    const videoId = pathParts[pathParts.length - 2]
    return new URL(`https://rutube.ru/play/embed/${videoId}/`).toString()
  }

  if (videoUrl.host === 'kinescope.io') {
    const pathParts = videoUrl.pathname.split('/')
    const videoId = pathParts[pathParts.length - 1]
    return new URL(`https://kinescope.io/embed/${videoId}`).toString()
  }

  return videoUrl.toString()
}
